import { render } from "./CommunityLinks.vue?vue&type=template&id=8904dd0e&scoped=true"
const script = {}

import "@/assets/style/mainpage.css?vue&type=style&index=0&id=8904dd0e&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8904dd0e"]])

export default __exports__